import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPARelationStart,
  getPARelationSuccess,
  getPARelationFailure,
} from "../reducers/getPARelationReducer.js";
import axios from "axios";
import Cookies from "js-cookie";

export const getPARelation = createAsyncThunk(
  "getPARelation",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getPARelationStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/PA/GetBenificiaryRelation`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getPARelationSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getPARelationFailure(error.response.data.Message));

      throw error;
    }
  }
);
